<template>
  <div class="edit-live-review-tracker-coverage-legend is-flex is-flex-wrap-wrap">
    <div
      v-for="tier in tiers"
      :key="tier.label"
      class="edit-live-review-tracker-coverage-legend__item is-flex is-align-items-center is-size-7 mr-5"
    >
      <span
        class="edit-live-review-tracker-coverage-legend__swatch mr-2"
        :style="{ backgroundColor: tier.color }"
      />
      <span class="has-text-weight-semibold">{{ tier.label }}</span>
      <span class="has-text-grey ml-1">{{ tier.range }}</span>
    </div>
  </div>
</template>

<script>
import { COVERAGE_TIERS } from './EditLiveReviewTrackerTraceLayer.vue'

export default {
  name: 'EditLiveReviewTrackerCoverageLegend',

  created() {
    this.tiers = COVERAGE_TIERS
  },
}
</script>

<style lang="scss">
@import 'variables';

.edit-live-review-tracker-coverage-legend {
  &__item {
    margin-bottom: $spacing-xs;
  }

  &__swatch {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
    border-radius: $border-radius-s;
    border: 1px solid rgba($color-secondary-darkest, 0.15);
  }
}
</style>
